/**
 * Returns the query string for this location.
 * When URL uses path#cfi?params (CFI before params), the params are in the fragment;
 * this returns the part after "?" so that URLSearchParams and consumers work the same.
 *
 * @param {{ pathname: string, search: string, hash: string }} location - location-like object
 * @returns {string} search string including leading "?" when non-empty, or ""
 */
const getSearchStringFromLocation = (location) => {
  if (location.search) {
    return location.search;
  }
  if (location.hash && location.hash.includes('?')) {
    return '?' + location.hash.split('?').slice(1).join('?');
  }
  return '';
};

export default getSearchStringFromLocation;
